import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisWizardPageComponent } from './his-wizard-page.component';
@Component( {
    selector: 'his-wizard-page-summary',
    templateUrl: './his-wizard-page-summary.component.html',
    styleUrls: ['./his-wizard-page-summary.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisWizardPageSummaryComponent implements AfterContentInit, AfterViewInit {
    changeDetector = inject(ChangeDetectorRef);

    /**
     * Used to define the header title of the tab.
     * @group Props
     */
    @Input() public title: string | undefined;
    /**
     * Used to define an unique identifier other than the index for better
     * control in dynamic wizard-pages szenarios
     * @group Props
     */
    @Input() public pageKey: string | undefined;
    wizardPage: HisWizardPageComponent;


    constructor() {
        const wizardPage = inject(HisWizardPageComponent);

        this.wizardPage = wizardPage as HisWizardPageComponent;
        
    }

    ngAfterViewInit(): void {
        console.log( 'ngAfterViewInit not implemented' );
    }

    ngAfterContentInit() {
        console.log( 'ngAfterContentInit not implemented' );
    }

    // isContainingFormValid() {
    //     if ( ! this.reactiveFormChild ) return false;
    //     return this.reactiveFormChild.form.status === 'VALID' ? true : false;
    // }

}
